import { useQuery } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS } from '@src/query';
import { ApiTypes } from 'common';
import { ApiError } from '@src/services/api';
import { getWidgets } from './api';

/**
 * Get widgets
 */
export const useQueryWidgets = () => useQuery<ApiTypes.ResGetWidgetList, ApiError | Error>({ queryKey: [DEPRECATED_QUERY_KEYS.WIDGETS], queryFn: getWidgets });
